/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router-dom';
import Addons from '../../../../components/Web/Addons/redesign/index';
import * as addonActions from '../../actions';
import * as loaderActions from '../../../../components/common/Loader/action';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import saga from '../../sagas';
import cartSaga from '../../../../services/Cart/sagas';
import taggingSaga from '../../../Common/Tagging.js/sagas';
import addons from '../../reducer';
import * as cartActions from '../../../../services/Cart/actions';
import * as taggingActions from '../../../Common/Tagging.js/actions';
import { checkPlanReferenceData } from '../../../../utils/plansReference';
// import * as BaseSelectors from '../selectors/basetemplateSelectors';

const mapStateToProps = (state) => {
  const addonsData = state.addons || {};
  const plansReferenceData = checkPlanReferenceData(state.plansReferenceData);
  const cartDetails = state.cartDetails || {};
  const currentView = state.currentView || {};
  const npaxx = addonsData && addonsData.getNPANXX;
  const addonObj = addonsData && addonsData.addonObj && addonsData.addonObj.oddOnListArr;
  const addonRefObj = addonsData?.addonRef || [];
  const addOnApiFlag = addonsData?.addOnApiFlag;
  const addonsinvalidCaseError = addonsData?.addonInvalidCaseError;
  const showSkipButton = addonsData?.showSkipBtn;
  const isAssignMtnSuccess = addonsData?.isAssignMtnSuccess;
  const apiLoaded = state.SessionValues?.apiLoaded;
  const channelSession = state.tagging?.channelSession;
  const updateAddonsProcessstep = state.addons?.updateAddonsProcessstep;
  const nextProcessStep = state.Redirection?.nextProcessStep;
  const isDowngradeRedemption = addonsData?.isDowngradeRedemption;
  const addFeatureapiStatus = addonsData && addonsData?.addFeatureapiStatus;
  const visionPendingApiStatus = addonsData && addonsData?.visionPendingApiStatus;
  const isModalOpen = addonsData && addonsData?.isModalOpen;
  const visionPendingOrder = addonsData && addonsData?.visionPendingOrder;

  return {
    addonsData,
    plansReferenceData,
    cartDetails,
    currentView,
    npaxx,
    addonObj,
    addonRefObj,
    addOnApiFlag,
    addonsinvalidCaseError,
    showSkipButton,
    isAssignMtnSuccess,
    apiLoaded,
    channelSession: channelSession || null,
    updateAddonsProcessstep,
    nextProcessStep,
    isDowngradeRedemption,
    addFeatureapiStatus,
    visionPendingApiStatus,
    isModalOpen,
    visionPendingOrder,
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...addonActions,
      ...cartActions,
      ...loaderActions,
      ...taggingActions,
    },
    dispatch,
  );
}

const withReducer = compose(injectReducer({ key: 'addons', reducer: addons }));

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withSaga = compose(
  injectSaga({ key: 'addons', saga }),
  injectSaga({ key: 'cartDetails', saga: cartSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
  // injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
);

export default withRouter(compose(withReducer, withSaga, withConnect)(Addons));
